import React from "react";
import ImiProfileCard from "./ImiProfileCard";

const ImiProfile = () => {
  return <ImiProfileCard />;
};

export default ImiProfile;
